import React, { useContext } from "react";
import {
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  useWindowDimensions,
  Platform,
} from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";
import {
  DrawerContentScrollView,
  DrawerItemList,
} from "@react-navigation/drawer";
import Report from "../screens/DrawerScreens/Report";
import Contributors from "../screens/DrawerScreens/Contributors";
import PillarScreen from "../screens/Pillar";
import ImprovementReport from "../screens/DrawerScreens/improvementReport";
import EmployeeTopicStatus from "../screens/DrawerScreens/EmployeeTopicStatus";
import FeedbackPage from "../screens/DrawerScreens/Feedback";
import { AuthContext } from "../Context/AuthContext";
import ESG_logoImage from "../assets/ESG_logo.png";
import GlobalStyles from "./StylenColor";
import DepartmentScoresScreen from "../screens/DrawerScreens/DepartmentScoresScreen";

const DrawerScreen = createDrawerNavigator();

function CustomDrawerContent(props) {
  const { companyName, logoutCompany } = useContext(AuthContext);
  const { width } = useWindowDimensions();
  const isLargeScreen = Platform.OS === "web" && width > 900;
  const { navigation } = props;

  const handleLogout = async () => {
    await logoutCompany();
    navigation.reset({
      index: 0,
      routes: [{ name: "CompanyLoginScreen" }], // 👈 change to your login screen name
    });
  };

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: GlobalStyles.GlobalBg.backgroundColor,
      }}
    >
      <DrawerContentScrollView
        {...props}
        contentContainerStyle={styles.drawerContainer}
      >
        <View style={styles.headerContainer}>
          <Image
            source={ESG_logoImage}
            style={{
              height: isLargeScreen ? 100 : 70,
              width: isLargeScreen ? 100 : 70,
              borderRadius: 50,
            }}
          />
          <Text
            style={[
              styles.companyName,
              {
                fontSize: isLargeScreen
                  ? GlobalStyles.fontSize.md
                  : GlobalStyles.fontSize.lg,
              },
            ]}
          >
            {companyName}
          </Text>
        </View>

        <DrawerItemList {...props} />
      </DrawerContentScrollView>

      {/* Logout Button at Bottom */}
      <TouchableOpacity style={styles.logoutButton} onPress={handleLogout}>
        <Text style={styles.logoutText}>Logout</Text>
      </TouchableOpacity>
    </View>
  );
}

export default function Drawer() {
  const { width } = useWindowDimensions();
  const isLargeScreen = width > 768;

  return (
    <DrawerScreen.Navigator
      drawerContent={(props) => <CustomDrawerContent {...props} />}
      screenOptions={{
        drawerStyle: {
          backgroundColor: GlobalStyles.GlobalBg.backgroundColor,
          width: isLargeScreen ? 300 : "70%",
        },
        drawerLabelStyle: {
          fontFamily: GlobalStyles.inpFont.fontFamily,
          fontSize: isLargeScreen
            ? GlobalStyles.fontSize.sm - 3
            : GlobalStyles.fontSize.sm - 1,
        },
        drawerActiveTintColor: "white",
        drawerInactiveTintColor: GlobalStyles.btnColor.backgroundColor,
        drawerActiveBackgroundColor: GlobalStyles.btnColor.backgroundColor,
        headerStyle: {
          backgroundColor: GlobalStyles.btnColor.backgroundColor,
        },
        headerTintColor: "white",
        headerTitleStyle: {
          fontFamily: GlobalStyles.GlobalFont.fontFamily,
          fontSize: isLargeScreen
            ? GlobalStyles.fontSize.lg
            : GlobalStyles.fontSize.xl,
          ...GlobalStyles.btntxtoffset,
          paddingVertical: 1,
        },
        headerTitleAlign: "center",
        headerShown: false,
        headerRight: () => (
          <View style={{ marginRight: 10 }}>
            <Image
              source={ESG_logoImage}
              style={{
                width: isLargeScreen ? 40 : 35,
                height: isLargeScreen ? 40 : 35,
                resizeMode: "contain",
              }}
            />
          </View>
        ),
      }}
    >
      <DrawerScreen.Screen name="ESG Pillars" component={PillarScreen} options={{ headerShown: false}}/>
      <DrawerScreen.Screen name="Contributors" component={Contributors} />
      <DrawerScreen.Screen
        name="Dept Performance"
        component={DepartmentScoresScreen}
        options={{
          title: "Department Performance", // This is the drawer title
        }}
      />
      <DrawerScreen.Screen name="Report" component={Report} />
      <DrawerScreen.Screen
        name="Improvement Report"
        component={ImprovementReport}
      />
      <DrawerScreen.Screen
        name="Remaining Topics"
        component={EmployeeTopicStatus}
      />
      <DrawerScreen.Screen name="Feedback & Support" component={FeedbackPage} />
    </DrawerScreen.Navigator>
  );
}

const styles = StyleSheet.create({
  drawerContainer: {
    flexGrow: 1,
    marginTop: 10,
    backgroundColor: GlobalStyles.GlobalBg.backgroundColor,
  },
  headerContainer: {
    alignItems: "center",
    marginBottom: 20,
    paddingTop: 10,
  },
  companyName: {
    marginTop: 10,
    fontFamily: GlobalStyles.GlobalFont.fontFamily,
    color: GlobalStyles.btnColor.backgroundColor,
  },
  logoutButton: {
    backgroundColor: GlobalStyles.btnColor.backgroundColor,
    paddingVertical: 12,
    alignItems: "center",
  },
  logoutText: {
    color: "white",
    fontFamily: GlobalStyles.GlobalFont.fontFamily,
    fontSize: GlobalStyles.fontSize.xs,
  },
});
